import { render, staticRenderFns } from "./StaffHcTable.vue?vue&type=template&id=32fa0b0f&scoped=true"
import script from "./StaffHcTable.vue?vue&type=script&lang=js"
export * from "./StaffHcTable.vue?vue&type=script&lang=js"
import style0 from "./StaffHcTable.vue?vue&type=style&index=0&id=32fa0b0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa0b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32fa0b0f')) {
      api.createRecord('32fa0b0f', component.options)
    } else {
      api.reload('32fa0b0f', component.options)
    }
    module.hot.accept("./StaffHcTable.vue?vue&type=template&id=32fa0b0f&scoped=true", function () {
      api.rerender('32fa0b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staffManage/resource/components/StaffHcTable.vue"
export default component.exports